<template>
	<div class="input-group">
		<div class="input-group-btn">
			<select class="btn btn-default" v-model="operador">
				<option :value="null">Selecione</option>
				<option value=">">Depois de</option>
				<option value="=">Igual a</option>
				<option value="<">Antes de</option>
				<option value="><">Período</option>
			</select>
		</div>
		<div class="datepicker-trigger">
			<button type="text" :id="name" :placeholder="placeholder" class="form-control" :disabled="!operador" style="text-align: left;">{{formatDates(data, data2, operador)}}</button>
			<AirbnbStyleDatepicker
				:trigger-element-id="name"
				:mode="operador != '><' ? 'single' : 'range'"
				:monthsToShow="operador != '><' ? 1 : 2"
				:fullscreen-mobile="true"
				:showActionButtons="false"
				:showShortcutsMenuTrigger="false"
				:date-one="data"
				:date-two="data2"
				@date-one-selected="val => { data = val }"
				@date-two-selected="val => { data2 = val }"
			/>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	$_veeValidate: {
		name() {
			return this.name;
		},
		value() {
			return this.data;
		}
	},

	props: {
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		selecionado: {
			type: String,
			default: null
		},
	},

	data: function() {
		return {
			data: null,
			data2: null,
			operador: this.selecionado,
		}
	},
	computed: {},
	mounted() {},
	methods: {
		formatDates (dateOne, dateTwo, ope) {
			let formattedDates = ''
			if (dateOne) {
				formattedDates = moment(dateOne).format("DD/MM/YYYY")
			}
			if (dateTwo && ope == '><') {
				formattedDates += ' a ' + moment(dateTwo).format("DD/MM/YYYY")
			}
			return formattedDates
		}
	},
	watch: {
		operador: function(value, oldValue) {
			this.$emit('operadorSelecionado', value);
			if (value != '><') {
				this.data2 = null;
				this.$emit('data2Selecionada', null);
			}
			if (!value) {
				this.data = null;
				this.data2 = null;
				this.$emit('input', null);
				this.$emit('dataSelecionada', null);
				this.$emit('data2Selecionada', null);
			}
		},
		data: function(value, oldValue) {
			this.$emit('input', value);
			this.$emit('dataSelecionada', value);
		},
		data2: function(value, oldValue) {
			this.$emit('data2Selecionada', value);
		}
	}
}
</script>

<style scoped>
.btn > option {
	background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// DataFiltro.vue?986da37e